__turbopack_context__.v({
  "addExtraPadding": "SubNavItem-module__iLaS3G__addExtraPadding",
  "imageList": "SubNavItem-module__iLaS3G__imageList",
  "showAll": "SubNavItem-module__iLaS3G__showAll",
  "standardList": "SubNavItem-module__iLaS3G__standardList",
  "subNavListWrapper": "SubNavItem-module__iLaS3G__subNavListWrapper",
});
